import { Box, Stack, Typography } from '@mui/material';
import { tokens } from '../theme';

type Tone = 'info' | 'warn' | 'bad';

const TONE = {
  info: { bg: '#EEF6F6', border: '#C9E4E3', text: '#215A59', icon: tokens.teal, glyph: 'i' },
  warn: { bg: tokens.amberBg, border: '#F3D8B7', text: '#5C4426', icon: tokens.amber, glyph: '!' },
  bad: { bg: tokens.roseBg, border: '#EFCFD5', text: tokens.roseText, icon: tokens.rose, glyph: '×' },
} as const;

/**
 * Hộp ghi chú — khối `\.note` của demo. Dùng thay `Alert` của MUI vì Alert mang
 * bảng màu riêng của nó, đặt cạnh các khối khác trong màn sẽ lệch tông.
 */
export function Note({ tone = 'info', children }: { tone?: Tone; children: React.ReactNode }) {
  const t = TONE[tone];
  return (
    <Stack
      direction="row"
      spacing={1.5}
      sx={{
        bgcolor: t.bg,
        border: `1px solid ${t.border}`,
        color: t.text,
        borderRadius: '10px',
        px: 1.9,
        py: 1.6,
        fontSize: 13.5,
      }}
    >
      <Box
        sx={{
          flex: 'none',
          width: 22,
          height: 22,
          borderRadius: '50%',
          bgcolor: t.icon,
          color: '#fff',
          display: 'grid',
          placeItems: 'center',
          fontSize: 13,
          fontWeight: 700,
          lineHeight: 1,
        }}
      >
        {t.glyph}
      </Box>
      <Typography sx={{ fontSize: 13.5, color: 'inherit' }}>{children}</Typography>
    </Stack>
  );
}
